import { DataResult } from '@/utils/mockUtils'
export default {
  getFileList () {
    const data = [
      {
        id: 55,
        title: "用户手册", //名称
        url: 'https://mp.weixin.qq.com/s/Mz1onElfRnorj1LDUHqjfQ',
        category: {
          name: '111'
        },
        type: "PDF",
        createTime: 12121312312,
        updateTime: 12121312312 
        },
        {
          id: 56,
          title: "用户手册", //名称
          url: 'https://mp.weixin.qq.com/s/Mz1onElfRnorj1LDUHqjfQ',
          category: {
            name: '111'
          },
          type: "PDF",
          createTime: 12121312312,
          updateTime: 12121312312 
          } ,
          {
            id: 55,
            title: "用户手册", //名称
            url: 'https://mp.weixin.qq.com/s/Mz1onElfRnorj1LDUHqjfQ',
            category: {
              name: '111'
            },
            type: "PDF",
            createTime: 12121312312,
            updateTime: 12121312312 
            } ,
            {
              id: 55,
              title: "用户手册", //名称
              url: 'https://mp.weixin.qq.com/s/Mz1onElfRnorj1LDUHqjfQ',
              category: {
                name: '111'
              },
              type: "PDF",
              createTime: 12121312312,
              updateTime: 12121312312 
              }   
    ]
    return DataResult.getSuccessResponse({itemArr: data, total: 5})
  }
}